import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as ApexCharts from 'apexcharts';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { JsignalService } from 'src/app/shared/services/jsignal.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { catchError, finalize, forkJoin, of, switchMap } from 'rxjs';
import * as moment from 'moment';


@Component({
    selector: 'app-jsip-dashboard',
    templateUrl: './jsip-dashboard.component.html',
    styleUrls: ['./jsip-dashboard.component.scss'],
    standalone: false
})
export class JsipDashboardComponent implements OnInit {

  productOptions = [ { label: 'All Products', value: null }];

  alertOptions = [
    { label: 'All Alerts', value: null },
    { label: 'Company DB', value: 'Company DB' },
    { label: 'FDA Alert', value: 'FDA Alert' },
    { label: 'SDR Geriatr', value: 'SDR Geriatr' },
    { label: ' SDR EB05 All', value:  'SDR EB05 All' },
  ];

  dataSourceOptions = [
    { label: 'All Datasource', value: null },
    { label: 'FAERS', value: 'FAERS' },
    { label: 'EVDAS', value: 'EVDAS' },
    { label: 'Safety Database', value: 'Safety Database' }
  ];
  rangeStartDate: any | null = null;
  rangeEndDate: any | null = null;
  startDate: any | null = null;
  endDate: any | null = null; 
   selectedProduct: string | null = null; 
  selectedAlert: string | null = null;
  selectedDataSource: string | null = null;
  isSidenavOpen=true;
  selectedProductDetails:any=null;
  UserRoleName:any;
reviewActivitiesList:any
productsList:any;
showReviewActivitiesChart

meetingsList:any
signalSummary:any;
allSignalsList:any=[]
 barChartOptions;

donutChartOptions = {
  chart: {
    type: 'donut',
    height: 180
  },
  series: [44, 55, 13, 43],
  labels: ['Open','New', 'Closed', 'Current Period'],
   dataLabels: {
          enabled: false
        },
  legend: {
    position: 'right',
    offsetY: 30
  },
  stroke: {
    width: 0, // ✅ removes border
  },

  plotOptions: {
    pie: {
      donut: {
        size: '70%' // ✅ thinner donut
      }
    }
  },
  colors: ['#FFA226', '#4AB9DC', '#FF3572', '#307B75']
};

pieChartOptions:any;

signalsDetected:any=0;
signalsValidated:any=0;
signalsAssessment:any=0;
signalsCommunicated:any=0;

funnelChartOptions:any;

 SignaloriginatedChartOptions:any;

 productsChartOptions = {
  chart: {
    type: 'bar',
    height: 230
  },
  grid: {
  yaxis: {
    lines: {
      show: false
    }
  }
},
  series: [
    {
      name: 'Review Status',
      data: [30, 40, 45, 50, 49]
    }
  ],
  xaxis: {
    categories: ['Approved', 'Pre-approved', 'Un-Approved', 'De-Registered', 'Retired']
  },
  dataLabels: {
    enabled: false
  },
  title: {
    text: 'Products Lifecycle State'
  },
  plotOptions: {
  bar: {
    columnWidth: '40%',
    distributed: true, // optional for spacing effect
    borderRadius: 15
  }
},
 stroke: {
    width: 0, // ✅ removes border
  },
legend: {show:false},
fill: {
  type: 'gradient',
  gradient: {
    type: 'vertical',
    shade: 'light',           // doesn’t matter much here
    shadeIntensity: 0,        // 👈 IMPORTANT (no color change)
    gradientToColors: undefined, // 👈 keep same color
    opacityFrom: 1,           // 👈 top = full color
    opacityTo: 0.1,           // 👈 bottom = faded
    stops: [0, 100]
  }
},
   colors: ['#fc6c6c', '#fec601', '#ff6700', '#00BE65','#02a9ea']
};
userName:any;
  constructor(private spinner: NgxUiLoaderService,
      private dialog: MatDialog,
      private jsignalsService: JsignalService,
       private snackBar: MatSnackBar,
       private localStorage: LocalStorageSettingsService,
        private linkservice: ReportlinksserviceService
    ) { }

  ngOnInit(): void {
     const today = new Date();

  this.rangeEndDate = today;

  const start = new Date(today);
  const day = start.getDate();

  start.setMonth(start.getMonth() - 3);

  // Fix overflow (e.g., Feb issue)
  if (start.getDate() !== day) {
    start.setDate(0); // last valid date of previous month
  }

  this.rangeStartDate = start;
    // let chart = new ApexCharts(document.querySelector("#chart"), this.options);
  this.userName= this.localStorage.getSettings('AuthUser')
    // chart.render();
    this.loadPageData()
  }

  async onProductFilter(value: any){
    this.selectedProduct = value ?? null;
    console.log(value);
    if(value){
    this.loadPageDataOnFilters()
    }else{
      this.loadPageData()
    }
  }

  

  async onDataSourceFilter(value: any){
    this.selectedDataSource = value ?? null;
     this.spinner.start()
    // await this.applyFilters();
    this.spinner.stop()
  }

  async onDateRangeChange() {
    console.log(this.rangeStartDate);
    console.log(this.rangeEndDate);
    
  if (this.rangeStartDate && this.rangeEndDate) {
    const start = new Date(this.rangeStartDate);
    start.setHours(0,0,0,0);

    const end = new Date(this.rangeEndDate);
    end.setHours(23,59,59,999);
    this.spinner.start()
    // await this.applyDateRangeFilter(start, end);
    this.spinner.stop()
  }
}

 loadPageData(): void {
    this.spinner.start();
 const startDate = this.rangeStartDate
    ? moment(this.rangeStartDate).format('YYYY-MM-DD')
    : null;

  const endDate = this.rangeEndDate
    ? moment(this.rangeEndDate).format('YYYY-MM-DD')
    : null;
let productId;
if(this.selectedProduct){
  productId=this.selectedProduct
}
  console.log(startDate); // 2026-03-31
  console.log(endDate);   // 2026-04-27
    this.linkservice
      .fetchUserRole(
        this.localStorage.getSettings('dnsName'),
        this.localStorage.getSettings('AuthUsername')
      )
      .pipe(
        switchMap((roleRes: any) => {
          console.log('Role response:', roleRes);

          this.UserRoleName = roleRes.roleName;

          return forkJoin({
            products: this.jsignalsService.getProductList().pipe(
                catchError((err) => {
                  console.error('Activities API failed', err);
                  return of([]);
                })
              ),
            activities: this.jsignalsService
              .getAllActivitesBasedOnRoleAndDateRange(this.UserRoleName,startDate,endDate,productId)
              .pipe(
                catchError((err) => {
                  console.error('Activities API failed', err);
                  return of([]);
                })
              ),

              meetings: this.jsignalsService
                .getAllMeetings().pipe(
                catchError((err) => {
                  console.error('Meetings API failed', err);
                  return of([]);
                })
              ),
              signalSummary: this.jsignalsService
              .getSignalCounts().pipe(
                catchError((err) => {
                  console.error('Meetings API failed', err);
                  return of([]);
                })
              ),
              allSignals:  this.jsignalsService
              .getAllSignals().pipe(
                catchError((err) => {
                  console.error('Meetings API failed', err);
                  return of([]);
                })
              ),
              
            // users: this.userService
            //   .getUsers()
            //   .pipe(
            //     catchError((err) => {
            //       console.error('Users API failed', err);
            //       return of([]);
            //     })
            //   ),
          });
        }),
        finalize(() => {
          this.spinner.stop();
        })
      )
      .subscribe({
        next: (res: any) => {
          console.log('All API responses:', res);
          this.productsList=this.setProducts(res.products)
          this.reviewActivitiesList = res.activities.map(row => this.processActivityRow(row));  
          console.log( this.reviewActivitiesList);
          this.meetingsList=this.processMeetings(res.meetings);
          this.signalSummary= this.getSignalCounts(res.signalSummary)
          console.log(this.meetingsList);
          this.allSignalsList=this.signalDetails(res.allSignals)
          this.allSignalsList=this.signalsPerProduct(res.allSignals)
          this.calculateStats();
          
        },
        error: (err) => {
          console.error('Role API or unexpected error:', err);
          this.snackBar.open(
            err?.error?.statusMessage || 'Something went wrong while loading data',
            'Ok',
            { duration: 3000 }
          );
        }
      });
  }

 loadPageDataOnFilters(): void {
    this.spinner.start();
 const startDate = this.rangeStartDate
    ? moment(this.rangeStartDate).format('YYYY-MM-DD')
    : null;

  const endDate = this.rangeEndDate
    ? moment(this.rangeEndDate).format('YYYY-MM-DD')
    : null;
let productId;
if(this.selectedProduct){
  productId=this.selectedProduct
}
  console.log(startDate); // 2026-03-31
  console.log(endDate);   // 2026-04-27
    this.linkservice
      .fetchUserRole(
        this.localStorage.getSettings('dnsName'),
        this.localStorage.getSettings('AuthUsername')
      )
      .pipe(
        switchMap((roleRes: any) => {
          console.log('Role response:', roleRes);

          this.UserRoleName = roleRes.roleName;

          return forkJoin({
            activities: this.jsignalsService
              .getAllActivitesBasedOnRoleAndDateRange(this.UserRoleName,startDate,endDate,productId)
              .pipe(
                catchError((err) => {
                  console.error('Activities API failed', err);
                  return of([]);
                })
              ),
              signalSummary: this.jsignalsService
              .getSignalCountByProductIds(this.selectedProduct,startDate,endDate).pipe(
                catchError((err) => {
                  console.error('Meetings API failed', err);
                  return of([]);
                })
              ),
              allSignals:  this.jsignalsService
              .getSignalsByProductIds(this.selectedProduct,startDate,endDate).pipe(
                catchError((err) => {
                  console.error('Meetings API failed', err);
                  return of([]);
                })
              ),
          });
        }),
        finalize(() => {
          this.spinner.stop();
        })
      )
      .subscribe({
        next: (res: any) => {
          console.log('All API responses:', res);
          this.reviewActivitiesList = res.activities.map(row => this.processActivityRow(row));  
          console.log( this.reviewActivitiesList);
          this.signalSummary= this.getSignalCounts(res.signalSummary)
          console.log(this.meetingsList);
          this.allSignalsList=this.signalDetails(res.allSignals)
          this.allSignalsList=this.signalsPerProduct(res.allSignals)
          this.calculateStats();
          
        },
        error: (err) => {
          console.error('Role API or unexpected error:', err);
          this.snackBar.open(
            err?.error?.statusMessage || 'Something went wrong while loading data',
            'Ok',
            { duration: 3000 }
          );
        }
      });
  }
  
 processMeetings(data: any[]) {
  const map = new Map();

  data
    .filter(m => m.isLatest && m.status === 'Yes')
    .forEach(m => {
      map.set(m.meetingId, m);
    });

  const meetings = Array.from(map.values());

  return meetings.sort((a, b) => {
    const statusA = this.getPriority(a);
    const statusB = this.getPriority(b);

    // First sort by status priority
    if (statusA !== statusB) {
      return statusA - statusB;
    }

    // Then sort by time within same category
    return this.getTime(a) - this.getTime(b);
  });
}

getPriority(meeting) {
  const now = new Date().getTime();
  const start = this.getTime(meeting);
  const end = new Date(`${meeting.meetingStartDate}T${meeting.meetingEndTime}`).getTime();

  if (now >= start && now <= end) return 1; // Ongoing
  if (now < start) return 2;               // Upcoming
  return 3;                                // Completed (last)
}

getTime(meeting: any): number {
  return new Date(`${meeting.meetingStartDate}T${meeting.meetingStartTime}`).getTime();
}

getEndTime(meeting: any): number {
  return new Date(`${meeting.meetingStartDate}T${meeting.meetingEndTime}`).getTime();
}

getMeetingStatus(meeting: any): 'upcoming' | 'ongoing' | 'completed' {
  const now = Date.now();
  const start = this.getTime(meeting);
  const end = this.getEndTime(meeting);

  if (meeting.isRecurring) {
    return now >= start && now <= end ? 'ongoing' : 'upcoming';
  }

  if (now < start) return 'upcoming';
  if (now >= start && now <= end) return 'ongoing';
  return 'completed';
}


formatTime(time: string): string {
  const [h, m] = time.split(':');
  const date = new Date();
  date.setHours(+h, +m);

  return date.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit'
  });
}

openMeeting(link: string) {
  window.open(link, '_blank');
}

  private processActivityRow(row: any) {
  const updatedRow = { ...row };

  try {
    updatedRow.isOverdue = false; // default

    updatedRow.isOverdue = this.isActivityOverdue(updatedRow);

  } catch (error) {
    console.error(error);
    this.snackBar.open(error, "Ok", { duration: 3000 });
  }

  return updatedRow;
}
  private isActivityOverdue(row: any): boolean {
    if (!row?.activityDueDate) {
      return false;
    }

    const dueDate = new Date(row.activityDueDate);
    if (isNaN(dueDate.getTime())) {
      return false;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return (
      dueDate < today &&
      row.scheduleState !== 'Completed'
    );
  }

  calculateDays(dueDate: string): number {
  const today = new Date();
  const due = new Date(dueDate);

  // Remove time part (important)
  today.setHours(0, 0, 0, 0);
  due.setHours(0, 0, 0, 0);

  const diffTime = today.getTime() - due.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays;
}

calculateStats() {
    let newCount = this.reviewActivitiesList.filter(
      (d) => d.scheduleState === "New"
    ).length;
   let inReviewCount = this.reviewActivitiesList.filter(
      (d) => d.scheduleState === "In Review"
    ).length;
    let completedCount = this.reviewActivitiesList.filter(
      (d) => d.scheduleState === "Completed"
    ).length;
   let overdueCount = this.reviewActivitiesList.filter(
      (d) => d.isOverdue == true
    ).length;
    let signalDetectedCount  = this.reviewActivitiesList.filter(
      (d) => d.signaldetected == 1 || d.signaldetected === "1"
    ).length;
   this.barChartOptions= {
  chart: {
    type: 'bar',
    height: 230
  },
  grid: {
  yaxis: {
    lines: {
      show: false
    }
  }
},
  series: [
    {
      name: 'Review Status',
      data:[newCount,inReviewCount,completedCount,overdueCount,signalDetectedCount]
    }
  ],
  xaxis: {
    categories: ['New Activities', 'In Review', 'Completed', 'Overdue', 'Signal Identified']
  },
  dataLabels: {
    enabled: false
  },
  title: {
    text: 'Review Activites'
  },
  plotOptions: {
  bar: {
    columnWidth: '40%',
    distributed: true, // optional for spacing effect
    borderRadius: 15
  }
},
 stroke: {
    width: 0, // ✅ removes border
  },
legend: {show:false},
fill: {
  type: 'gradient',
  gradient: {
    type: 'vertical',
    shade: 'light',           // doesn’t matter much here
    shadeIntensity: 0,        // 👈 IMPORTANT (no color change)
    gradientToColors: undefined, // 👈 keep same color
    opacityFrom: 1,           // 👈 top = full color
    opacityTo: 0.1,           // 👈 bottom = faded
    stops: [0, 100]
  }
},
   colors: ['#FFA226', '#4AB9DC', '#FF3572', '#307B75','#e24218']
};
  // this.barChartOptions.series[0].data=
}

getSignalCounts(res){
  console.log(res);
  
     this.signalsDetected = res.detected || 0;
    this.signalsValidated = res.validated || 0;
    this.signalsAssessment = res.assessed || 0;
    this.signalsCommunicated = res.communicated || 0;

this.funnelChartOptions = {
  chart: {
    type: 'bar',
    height: 230,
    toolbar: {
      show: true
    }
  },

  series: [
    {
      name: 'Signals',
      data: [
        { x: 'Detected', y:  this.signalsDetected },
        { x: 'Validated', y: this.signalsValidated },
        { x: 'Assessment', y:  this.signalsAssessment},
        { x: 'In Action', y:  this.signalsCommunicated },
        // { x: 'Closed', y: 1 }
      ]
    }
  ],

  plotOptions: {
    bar: {
      horizontal: true,
      isFunnel: true,
      isFunnel3d: true,
      barHeight: '80%',
      distributed: true,
      borderRadius: 0,
      dataLabels: {
        position: 'center'
      }
    }
  },

 colors: [
  '#26a0fc', // blue
  '#26e7a6', // green
  '#fbba3a', // yellow
  // '#f95f75', // red
  '#8b75d7'  // purple
],

  dataLabels: {
    enabled: true,
    textAnchor: 'middle',
    offsetX: 0,
    style: {
      colors: ['#ffffff'],
      fontSize: '11px',
      fontWeight: '500'
    },
    
    formatter: function (val: number, opts: any) {
      const label = opts.w.globals.labels[opts.dataPointIndex];
      return `${label}  ${val}`;
    },
    background: {
      enabled: false
    }
  },

  legend: {
    show: false
  },

  stroke: {
    width: 0
  },


  tooltip: {
    y: {
      formatter: function (val: number) {
        return `${val} signals`;
      }
    }
  },

  title: {
    text: 'Signal Summary'
  },
   grid: {
    padding: {
      top: -10
    }
  }
};
}

setProducts(res){
this.productOptions = res.map((item, index) => {
        if (!item || typeof item !== 'object') {
          throw new Error(`Invalid item at index ${index}: ${JSON.stringify(item)}`);
        }

        return {
          value: item.id,
          label: item.name
        } ;
      });
     this.productOptions = [ { label: 'All Products', value: null },...this.productOptions]
}

signalsPerProduct(res){
  const countMap = res.reduce((acc, item) => {
  acc[item.product] = (acc[item.product] || 0) + 1;
  return acc;
}, {});

const filtered = this.productOptions
  .map(p => ({ product: p.label, count: countMap[p.label] || 0 })).filter(p => p.count > 0);

const chartLabels = filtered.map(p => p.product);
const chartSeries = filtered.map(p => p.count);
console.log(chartLabels);
console.log(chartSeries);

this.pieChartOptions = {
  chart: {
    type: 'pie',
    height: 180
  },
  series: chartSeries,
  labels: chartLabels,
  // title: {
  //   text: 'Alert Summary',
  // },
   dataLabels: {
          enabled: false
        },
  legend: {
     show: false,
    // floating: true,
    position: 'right',
    // offsetX: 20,
    offsetY: 30
  },
  stroke: {
    width: 0, // ✅ removes border
  },

  plotOptions: {
    pie: {
      donut: {
        size: '70%' // ✅ thinner donut
      }
    }
  },
  colors: ['#FFA226', '#4AB9DC', '#FF3572', '#307B75']
};
}
signalDetails(res){
  const counts = res.reduce((acc, item) => {
  const type = item.signalType?.toLowerCase();
  acc[type] = (acc[type] || 0) + 1;
  return acc;
}, {});

const external = counts.external || 0;
const internal = counts.internal || 0;

 this.SignaloriginatedChartOptions = {
  series: [internal, external],
  chart: {
    type: 'donut',
    height: 180
  },
  labels: ['Internal', 'External'],
  plotOptions: {
    pie: {
      donut: {
        size: '70%',
        labels: {
          show: true,
          name: {
            show: true,
            fontSize: '14px'
          },
          value: {
            show: true,
            fontSize: '18px',
            fontWeight: 600
          },
          total: {
            show: true,
            label: 'Total',
            fontSize: '14px',
            formatter: function (w) {
              return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
            }
          }
        }
      }
    }
  },
  colors: ['#673bb7', '#ff005c']
};
}
}
